(() => {
  if (window.TDFWMobileHome) return;
  window.TDFWMobileHome = true;
  const initialized = new WeakSet();
  const mobile = window.matchMedia('(max-width: 1023.98px)');
  function init() {
    document.querySelectorAll('[data-mobile-app-home]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const dialog = root.querySelector('[data-app-menu]');
      const opener = root.querySelector('[data-menu-open]');
      let priorOverflow = '';
      function close() { if (dialog?.open) dialog.close(); }
      opener?.addEventListener('click', () => {
        if (!mobile.matches || !dialog || dialog.open) return;
        priorOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
      });
      dialog?.querySelector('[data-menu-close]')?.addEventListener('click', close);
      dialog?.addEventListener('click', event => { if (event.target === dialog || event.target.closest('a')) close(); });
      dialog?.addEventListener('close', () => { document.body.style.overflow = priorOverflow; opener.setAttribute('aria-expanded', 'false'); if (mobile.matches && opener.isConnected) opener.focus(); });
      function selectGroup(group) {
        root.querySelectorAll('[data-category-filter]').forEach(button => { const active = button.dataset.categoryFilter === group; button.classList.toggle('active', active); button.setAttribute('aria-pressed', String(active)); });
        root.querySelectorAll('[data-category-group]').forEach(panel => { panel.hidden = panel.dataset.categoryGroup !== group; });
      }
      selectGroup('used');
      root.addEventListener('click', event => { const filter = event.target.closest('[data-category-filter]'); if (filter) selectGroup(filter.dataset.categoryFilter); });
      const onResize = () => { if (!mobile.matches) close(); };
      mobile.addEventListener('change', onResize);
      root._mobileCleanup = () => { close(); mobile.removeEventListener('change', onResize); };
      root.classList.add('mah-enhanced');
      window.TDFWWishlist?.refresh();
    });
  }
  document.addEventListener('cart:updated', event => { if (event.detail?.cart) document.querySelectorAll('[data-mobile-cart-count]').forEach(counter => { counter.textContent = event.detail.cart.item_count; }); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', event => { const category = event.target.closest('.mah-category'); if (category) { const group = category.closest('[data-category-group]').dataset.categoryGroup; category.closest('[data-mobile-app-home]').querySelector('[data-category-filter="' + group + '"]')?.click(); } });
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-mobile-app-home]').forEach(root => root._mobileCleanup?.()); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();